import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "circles-2-overlapping-diagonal-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none" },
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7 5.5a4.5 4.5 0 0 1 4.307 5.807 4.5 4.5 0 0 1-5.614-5.614A4.497 4.497 0 0 1 7 5.5Z", opacity: 0.35 }),
        React.createElement("circle", { cx: 7, cy: 10, r: 4, stroke: "currentColor" }),
        React.createElement("circle", { cx: 10, cy: 7, r: 4, stroke: "currentColor" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
